import React from "react";
import "../../css/Agendas.css";
import * as Tooltip from "@radix-ui/react-tooltip";
import {InfoCircledIcon} from "@radix-ui/react-icons";

export type AgendaOption = {
    id:number,
    label:string,
    color:string,
    icon?:string
}

type AgendaProps = {
    selected: number[];
    onChange: (newSelected:number[]) => void;
    size:number;
    maxChoises?:number;
    title?:string;
}


const Agendas: React.FC<AgendaProps> = ({
    selected,
    onChange,
    size,
    maxChoises = 17,
    title="Agenda 2030"
}) =>
{
    const options: AgendaOption[] = [
        { id: 1, label: "No Poverty", color: "#e51d3c", icon: "🎵" },
        { id: 2, label: "No Hunger", color: "#dda63a", icon: "✈️" },
        { id: 3, label: "Good Health and well-being", color: "#4a9f37", icon: "💪" },
        { id: 4, label: "Good Education for all", color: "#e50e2c", icon: "🍳" },
        { id: 5, label: "Equality", color: "#e8412e", icon: "🎨" },
        { id: 6, label: "Clean water and sanitation for all", color: "#29bbe1", icon: "🎮" },
        { id: 7, label: "Sustainable energy for all", color: "#fbc218", icon: "📚" },
        { id: 8, label: "Decent working conditions and economic growth", color: "#a21942", icon: "⚽" },
        { id: 9, label: "Sustainable industry, innovations and infrastructure", color: "#fd6925", icon: "🎬" },
        { id: 10, label: "Reduced inequality", color: "#dd1367", icon: "🎨" },
        { id: 11, label: "Sustainable cities and communities", color: "#fd9d24", icon: "🎨" },
        { id: 12, label: "Sustainable consumption and production", color: "#bf8b2e", icon: "🎨" },
        { id: 13, label: "Combating climate change", color: "#3f7e44", icon: "🎨" },
        { id: 14, label: "Oceans and marine resources", color: "#0a97d9", icon: "🎨" },
        { id: 15, label: "Ecosystems and biodiversity", color: "#56c02b", icon: "🎨" },
        { id: 16, label: "Peaceful and inclusive societies", color: "#00689d", icon: "🎨" },
        { id: 17, label: "Implementation and global partnership", color: "#19486a", icon: "🎨" },
    ];

    const toggleAgenda = (id:number) => {
        const updated = selected.includes(id) ? selected.filter(i => i !== id) : [...selected, id];
        onChange(updated);
    }

    function InfoIcon({text}) 
        {
          return (
            <Tooltip.Provider>
              <Tooltip.Root>
                <Tooltip.Trigger asChild>
                  <InfoCircledIcon className="Info-icon"/>
                </Tooltip.Trigger>
                <Tooltip.Content className="TooltipContent" sideOffset={5}>
                  {text}
                </Tooltip.Content>
              </Tooltip.Root>
            </Tooltip.Provider>
          );
        }

    return (
        <>
            <div>
                <div style={{display:"flex", paddingTop:"3px"}}>
                    <span>{title}</span>
                    <InfoIcon text={"Click on a box to select/deselect. A selected box is highlighted with a black border."}/>
                </div>
                <hr></hr>
            </div>
            <div className="agenda-grid">
                {options.slice(0, maxChoises).map((opt) => {
                    const isSelected = selected.includes(opt.id);
                    return (
                        <button 
                            key={opt.id}
                            type="button"
                            onClick={() => toggleAgenda(opt.id)}
                            className={`agenda-button ${isSelected ? "selected" : ""}`}
                            style={{ 
                                backgroundColor: opt.color,
                                width:size,
                                height:size
                            }}
                        >
                            <span className="agenda-number">{opt.id}</span>
                            <span className="agenda-label">{opt.label}</span>
                        </button>
                    );
                })}
            </div>
        </>
    );
}

export default Agendas;